import Api from './ApiService'

export default {
    get(keyword, pageNumber, order) {
        return Api().get(`period?keyword=${keyword}&pageNumber=${pageNumber}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getActives() {
        return Api().get(`period/actives`);
    },
    getOne(id) {
        return Api().get(`period/${id}`);
    },
    create(data) {
        return Api().post(`period`, data);
    },
    update(data) {
        return Api().put(`period/${data.id}`, data);
    }
}